import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import AutoCarousel from '../../Helpers/Widgets/AutoCarousel/AutoCarousel';
import { makeStyles } from "@material-ui/core/styles";
import StarIcon from '@material-ui/icons/Star';
import SvgIcon from '@material-ui/core/SvgIcon';
import UserIcon from '../../../icons/user.svg';
import './Reviews.scss';

const useStyles = makeStyles(theme => ({
  circleBorder: {
    border: `4px solid ${theme.palette.primary.main}`
  }
}));

function Review(props) {

  const numStars = 5;
  const iconClass = props.data.avatar === "none" ? "icon-wrapper m-3" : "";
  return (
    <Col className="review">
      <Row className="avatar">
        <Col xs="auto" className={iconClass}>
          {props.data.avatar === "none" ?
            (<SvgIcon component={UserIcon} />) :
            (<Image src={props.data.avatar} roundedCircle className={props.classes} alt="" />)
          }

        </Col>
        <Col xs="auto" className="d-flex align-items-center justify-content-left stars">
          {[...Array(numStars).keys()].map((j) => <StarIcon key={j} color="primary" />
          )}
        </Col>
      </Row>
      <h3>{props.data.name}</h3>
      <p>{props.data.review}</p>
    </Col>
  )
}
export default function Reviews(props) {
  const classes = useStyles();
  const data = props.data;
  const data2 = data.map((d, index) => <Review key={index} data={d} classes={classes.circleBorder} />);

  return (
    <div className="reviews justify-content-center">
      <Container>
        <Row className="justify-content-center">
          <h2>What people are saying</h2>
        </Row>
        <Row className="large-screen">
          {data2}
        </Row>
        <Row className="small-screen">
          <AutoCarousel data={data2} />
        </Row>
      </Container >
    </div >
  )
}



// WEBPACK FOOTER //
// ./src/components/LandingPages/Reviews/Reviews.js